// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CountryBlockedQueryVariables = Types.Exact<{
  site?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CountryBlockedQuery = { __typename?: 'Query', userManagement?: { __typename?: 'UserManagement', id: string, currentCountryInfo?: { __typename?: 'UserManagementCountryInfo', id: string, countryCode?: string, blocked?: boolean } } };


export const CountryBlockedQueryDocument = /*#__PURE__*/ gql`
    query CountryBlockedQuery($site: String) {
  userManagement {
    id
    currentCountryInfo(site: $site) {
      id
      countryCode
      blocked
    }
  }
}
    `;
export function useCountryBlockedQuery(baseOptions?: Apollo.QueryHookOptions<CountryBlockedQuery, CountryBlockedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountryBlockedQuery, CountryBlockedQueryVariables>(CountryBlockedQueryDocument, options);
      }
export function useCountryBlockedQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountryBlockedQuery, CountryBlockedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountryBlockedQuery, CountryBlockedQueryVariables>(CountryBlockedQueryDocument, options);
        }
export function useCountryBlockedQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountryBlockedQuery, CountryBlockedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountryBlockedQuery, CountryBlockedQueryVariables>(CountryBlockedQueryDocument, options);
        }
export type CountryBlockedQueryHookResult = ReturnType<typeof useCountryBlockedQuery>;
export type CountryBlockedQueryLazyQueryHookResult = ReturnType<typeof useCountryBlockedQueryLazyQuery>;
export type CountryBlockedQuerySuspenseQueryHookResult = ReturnType<typeof useCountryBlockedQuerySuspenseQuery>;
export type CountryBlockedQueryQueryResult = Apollo.QueryResult<CountryBlockedQuery, CountryBlockedQueryVariables>;